export enum Language {
  ENGLISH = "ENGLISH",
  HEBREW = "HEBREW",
  ARABIC = "ARABIC",
  CHINESE = "CHINESE",
  DUTCH = "DUTCH",
  FRENCH = "FRENCH",
  GERMAN = "GERMAN",
  ITALIAN = "ITALIAN",
  JAPANESE = "JAPANESE",
  KOREAN = "KOREAN",
  PORTUGUESE = "PORTUGUESE",
  RUSSIAN = "RUSSIAN",
  SPANISH = "SPANISH",
  TURKISH = "TURKISH",
  HINDI = "HINDI",
  URDU = "URDU",
  BENGALI = "BENGALI",
  TAMIL = "TAMIL",
  TELEGU = "TELEGU",
  MARATHI = "MARATHI",
  PUNJABI = "PUNJABI",
  GUJARATI = "GUJARATI",
  MALAYALAM = "MALAYALAM",
  KANNADA = "KANNADA",
  THAI = "THAI",
  INDONESIAN = "INDONESIAN",
  VIETNAMESE = "VIETNAMESE",
  FILIPINO = "FILIPINO",
  MALAY = "MALAY",
  SWEDISH = "SWEDISH",
  NORWEGIAN = "NORWEGIAN",
  DANISH = "DANISH",
  FINNISH = "FINNISH",
  POLISH = "POLISH",
  GREEK = "GREEK",
  CZECH = "CZECH",
  ROMANIAN = "ROMANIAN",
  HUNGARIAN = "HUNGARIAN",
  UKRAINIAN = "UKRAINIAN",
  BULGARIAN = "BULGARIAN",
  SERBIAN = "SERBIAN",
  CROATIAN = "CROATIAN",
  SLOVAK = "SLOVAK",
  SLOVENIAN = "SLOVENIAN",
  LATVIAN = "LATVIAN",
  LITHUANIAN = "LITHUANIAN",
  ESTONIAN = "ESTONIAN",
}
